import React from 'react';
import {
  Modal,
  Fade,
  Backdrop,
  Box,
  Typography,
  TextField,
  Button,
  LinearProgress,
} from '@mui/material';
import {
  passwordStrength,
  strengthLabels,
  strengthColors,
} from '../utils/passwordUtils';

const styleModal = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: { xs: '90%', sm: 400 },
  maxWidth: '100%',
  bgcolor: 'background.paper',
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
};

const PasswordModal = ({ open, onClose, onUpdate, novaSenha, setNovaSenha }) => {
  const strength = passwordStrength(novaSenha);

  return (
    <Modal
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
      open={open}
      onClose={onClose}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{ backdrop: { timeout: 500 } }}
    >
      <Fade in={open}>
        <Box sx={styleModal}>
          <Typography id="modal-title" variant="h6" component="h2" gutterBottom>
            Alterar Senha
          </Typography>

          <TextField
            label="Nova Senha"
            type="password"
            fullWidth
            value={novaSenha}
            onChange={(e) => setNovaSenha(e.target.value)}
            margin="normal"
            autoFocus
            variant="outlined"
          />

          <Box sx={{ mt: 2, mb: 1 }}>
            <LinearProgress
              variant="determinate"
              value={(strength / 5) * 100}
              sx={{
                height: 8,
                borderRadius: 5,
                bgcolor: '#eee',
                '& .MuiLinearProgress-bar': {
                  bgcolor: strengthColors[strength],
                },
              }}
            />
            <Typography
              variant="caption"
              sx={{
                color: strengthColors[strength],
                fontWeight: 'bold',
                mt: 0.5,
                display: 'block',
              }}
            >
              {novaSenha ? strengthLabels[strength] : ''}
            </Typography>
          </Box>

          <Box sx={{ mt: 3, display: 'flex', justifyContent: 'space-between', gap: 2 }}>
            <Button variant="outlined" color="secondary" onClick={onClose} fullWidth>
              Cancelar
            </Button>
            <Button variant="contained" color="primary" onClick={onUpdate} fullWidth>
              Atualizar
            </Button>
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
};

export default PasswordModal;